(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3959],{

/***/ 2463:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/[...slug]",
      function () {
        return __webpack_require__(35806);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const MetricWidget = (param)=>{
    let { label , value , trend =null , icon , className =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `overflow-hidden bg-white rounded-lg shadow-md ${className}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "p-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-shrink-0",
                        children: icon
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 w-0 ml-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500 truncate",
                                    children: label
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-lg font-bold text-gray-900",
                                        children: value
                                    })
                                })
                            ]
                        })
                    }),
                    trend && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1 w-0 ml-5 text-right",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                                    className: "text-sm font-medium text-gray-500 truncate",
                                    children: "Trend"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-lg font-bold text-red-500",
                                        children: "N/A"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetricWidget);


/***/ }),

/***/ 46162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_shared_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99627);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);



const ObservationForm = (param)=>{
    let { subject , subjectLabel , disableSubmit , handleSubmit  } = param;
    const { register , handleSubmit: handleFormSubmit , reset , formState: { errors  }  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useForm */ .cI)();
    const onSubmit = (param)=>{
        let { description  } = param;
        handleSubmit({
            description,
            subject,
            source: "user",
            status: "unknown"
        });
        reset();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        onSubmit: handleFormSubmit(onSubmit),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full py-6 pl-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-sm font-medium leading-5 text-gray-900 truncate",
                    children: `New ${subjectLabel || subject}`
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 truncate",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-2 max-w-xl pr-5 rounded-md shadow-sm",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    id: "name",
                                    className: "block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5",
                                    autoComplete: "off",
                                    ...register("description", {
                                        required: "Please enter a description"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                type: "submit",
                                disabled: !!disableSubmit,
                                title: "Submit"
                            })
                        })
                    ]
                }),
                errors?.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-2 text-xs text-red-600",
                    children: errors?.description.message
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ObservationForm);


/***/ }),

/***/ 36242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33507);


const allStatusOptions = {
    success: {
        status: "success",
        label: "Success"
    },
    failure: {
        status: "failure",
        label: "Failure"
    },
    unknown: {
        status: "unknown",
        label: "Pending"
    },
    archived: {
        status: "archived",
        label: "Archived"
    }
};
const ObservationRow = (param)=>{
    let { observation , onChange  } = param;
    const { description , source , status  } = observation;
    const statusOptions = Object.values(allStatusOptions).filter((option)=>option.status !== status);
    let statusColor;
    switch(status){
        case "success":
            statusColor = "text-summer-green-700 bg-summer-green-100 border-summer-green-200 hover:bg-summer-green-200";
            break;
        case "unknown":
            statusColor = "text-san-juan-blue-500 bg-new-orleans-400 border-new-orleans-500 hover:bg-new-orleans-500";
            break;
        case "failure":
            statusColor = "text-apricot-700 bg-apricot-200 border-apricot-300 hover:bg-apricot-300";
            break;
        default:
            statusColor = "text-gray-800 bg-gray-100 border-gray-100 hover:bg-gray-200 focus:ring-gray-500 focus:border-gray-500";
    }
    const onChangeStatus = (status)=>{
        onChange({
            ...observation,
            status
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full py-6 pl-3 flex items-center justify-between",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-1 truncate",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-sm pr-10 whitespace-pre-wrap font-medium text-gray-900 truncate",
                            children: description
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-2 text-sm leading-5 text-gray-500 truncate",
                        children: [
                            "Created by ",
                            source
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Listbox */ .R, {
                    value: status,
                    onChange: onChangeStatus,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Listbox.Button */ .R.Button, {
                            className: `mt-2 px-6 py-2 rounded-md shadow-sm text-center cursor-pointer focus:outline-none focus:ring-1 font-medium text-sm ${statusColor}`,
                            children: allStatusOptions[status].label
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Listbox.Options */ .R.Options, {
                            className: "absolute z-10 mt-1 w-full cursor-pointer bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                            children: statusOptions.map((option)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Listbox.Option */ .R.Option, {
                                    value: option.status,
                                    className: (param)=>{
                                        let { active  } = param;
                                        return `${active ? "bg-gray-100" : ""} text-gray-900 select-none relative py-2 pl-3 pr-9`;
                                    },
                                    children: option.label
                                }, option.status))
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ObservationRow);


/***/ }),

/***/ 7268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30453);


const Loading = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "h-2/3 flex flex-col",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            width: "40",
            className: "flex-1 m-auto mt-6 animate-spin"
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 75598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);


const TooltipContent = (param)=>{
    let { active , payload , label  } = param;
    if (active && payload && payload.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-white border border-gray-100 px-4 py-2 focus:outline-none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-sm",
                    children: dayjs__WEBPACK_IMPORTED_MODULE_1___default().unix(label).format("MMMM D YYYY, h:mm:ss a")
                }),
                payload.filter((p)=>!p.name.startsWith("Threshold")).map((p, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-sm",
                        style: {
                            color: p.color
                        },
                        children: `${p.name} : ${p.value} `
                    }, i))
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (TooltipContent);


/***/ }),

/***/ 85505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mh": function() { return /* binding */ commonXAxisProps; },
/* harmony export */   "NT": function() { return /* binding */ buildVirtualUserPlots; },
/* harmony export */   "Qs": function() { return /* binding */ fillInTimeGaps; },
/* harmony export */   "fg": function() { return /* binding */ reduceChartsByLabel; },
/* harmony export */   "vs": function() { return /* binding */ buildResponseTimePlots; },
/* harmony export */   "yh": function() { return /* binding */ durationFormatter; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var d3_scale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88557);
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26599);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);




const tickFormatter = (timeStamp)=>{
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default().unix(timeStamp).format("h:mm:ss a");
};
const commonXAxisProps = {
    dataKey: "timeStamp",
    tickFormatter: tickFormatter
};
const durationFormatter = (range)=>{
    if (!range[1]) {
        return "Active";
    }
    const diff = Math.round((range[1] - range[0]) / 60);
    // TODO(bobsin): improve this to be dynamic based on diff size
    return `${diff} minute${diff == 1 ? "" : "s"}`;
};
const buildResponseTimePlots = (chartsByLabel)=>{
    return Object.values((0,lodash__WEBPACK_IMPORTED_MODULE_1__.reduce)(chartsByLabel, (memo, chart, label)=>{
        chart.timeStamps.forEach((timeStamp, i)=>{
            memo[timeStamp] = memo[timeStamp] || {
                timeStamp,
                metricByLabel: {}
            };
            memo[timeStamp].metricByLabel[label] = {
                avgMs: chart.latencyAvgMs[i],
                minMs: chart.latencyMinMs[i],
                maxMs: chart.latencyMaxMs[i],
                p50Ms: chart.latencyP50Ms[i],
                p75Ms: chart.latencyP75Ms[i],
                p90Ms: chart.latencyP90Ms[i],
                p95Ms: chart.latencyP95Ms[i],
                p99Ms: chart.latencyP99Ms[i]
            };
        });
        return memo;
    }, []));
};
const buildVirtualUserPlots = (chart)=>{
    const plots = [];
    chart.timeStamps.forEach((timeStamp, i)=>{
        plots.push({
            timeStamp,
            virtualUsers: chart.virtualUsers[i]
        });
    });
    return plots;
};
const reduceChartsByLabel = (chartsByLabel, path)=>{
    const groupedByTs = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.reduce)(chartsByLabel, (memo, chart, label)=>{
        chart.timeStamps.forEach((timeStamp, i)=>{
            memo[timeStamp] = memo[timeStamp] || {
                timeStamp,
                metricByLabel: {}
            };
            memo[timeStamp].metricByLabel[label] = chart[path][i];
        });
        return memo;
    }, []);
    return Object.values(groupedByTs);
};
const fillInTimeGaps = (rows, emptyRow, mergeRow)=>{
    if (rows.length === 0) {
        return [];
    }
    const startTime = dayjs__WEBPACK_IMPORTED_MODULE_0___default().unix(rows[0].timeStamp).toDate();
    const endTime = dayjs__WEBPACK_IMPORTED_MODULE_0___default().unix(rows[rows.length - 1].timeStamp).toDate();
    let currentIdx = 0;
    return (0,d3_scale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().domain([
        startTime,
        endTime
    ]).ticks(d3_time__WEBPACK_IMPORTED_MODULE_3__/* ["default"].every */ .Z.every(5)).map((date)=>{
        const unix = date.getTime() / 1000;
        const current = rows[currentIdx];
        if (unix < current.timeStamp) {
            return emptyRow(unix);
        } else if (unix === current.timeStamp) {
            currentIdx += 1;
            return mergeRow(unix, current);
        }
    });
};


/***/ }),

/***/ 85510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


const Footer = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-screen-xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                className: "-mx-5 -my-2 flex flex-wrap justify-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-5 py-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            className: "text-base leading-6 text-gray-600 hover:text-gray-800",
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-5 py-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://docs.latencylingo.com/docs/intro",
                            target: "_blank",
                            className: "leading-6 text-base text-gray-600 hover:text-gray-800",
                            rel: "noreferrer",
                            children: "Docs"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-5 py-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#features",
                            className: "text-base leading-6 text-gray-600 hover:text-gray-800",
                            children: "Features"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-5 py-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "#pricing",
                            className: "text-base leading-6 text-gray-600 hover:text-gray-800",
                            children: "Pricing"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-5 py-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog",
                            className: "text-base leading-6 text-gray-600 hover:text-gray-800",
                            children: "Blog"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-5 py-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "mailto:support@latencylingo.com",
                            className: "text-base leading-6 text-gray-600 hover:text-gray-800",
                            children: "Contact"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 90166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_home_Navbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53924);
/* harmony import */ var components_home_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85510);
/* harmony import */ var components_shared_NotificationBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83062);




const Layout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "min-h-screen h-1",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-summer-green-100 font-medium text-summer-green-700 border border-summer-green-300 py-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_shared_NotificationBar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    children: [
                        "New release!",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            className: "underline",
                            href: "/blog/github-actions-integration",
                            rel: "noreferrer",
                            children: "Github Actions Integration"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_Navbar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 53924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86215);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11355);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47516);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var react_icons_tb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37106);








const solutions = [
    {
        name: "Automated Testing",
        description: "Integrate with your CI/CD pipeline.",
        href: "/use-cases/automated-testing",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb__WEBPACK_IMPORTED_MODULE_3__/* .TbGitPullRequestClosed */ .$F$, {
            className: "w-5 h-5 sm:w-6 sm:h-6"
        })
    },
    {
        name: "Thresholds",
        description: "Measure against objectives.",
        href: "/product/thresholds",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdOutlineHealthAndSafety */ .T2A, {
            className: "w-5 h-5 sm:w-6 sm:h-6"
        })
    },
    {
        name: "Analysis",
        description: "Explore load test results.",
        href: "/product/analysis",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_tb__WEBPACK_IMPORTED_MODULE_3__/* .TbFileAnalytics */ .Hcj, {
            className: "w-5 h-5 sm:w-6 sm:h-6"
        })
    }
];
const useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        width: undefined,
        height: undefined
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const handleResize = ()=>setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowSize;
};
const ProductMenuLink = ()=>{
    const buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const timeoutDuration = 200;
    let timeout;
    const { width  } = useWindowSize();
    const closePopover = ()=>{
        return buttonRef.current?.dispatchEvent(new KeyboardEvent("keydown", {
            key: "Escape",
            bubbles: true,
            cancelable: true
        }));
    };
    const onMouseEnter = (open)=>{
        clearTimeout(timeout);
        if (open || width && width < 768) return;
        return buttonRef.current?.click();
    };
    const onMouseLeave = (open)=>{
        if (!open || width && width < 768) return;
        timeout = setTimeout(()=>closePopover(), timeoutDuration);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Popover */ .J, {
            className: "relative",
            children: (param)=>{
                let { open  } = param;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onMouseLeave: onMouseLeave.bind(null, open),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Popover.Button */ .J.Button, {
                                ref: buttonRef,
                                className: `${open ? "text-san-juan-blue-700" : "text-san-juan-blue-500"} mx-3 inline-flex items-center text-base focus:outline-none`,
                                onMouseEnter: onMouseEnter.bind(null, open),
                                onMouseLeave: onMouseLeave.bind(null, open),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Product"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_6__/* .BiChevronDown */ .OrA, {
                                        className: `${open ? "" : "text-opacity-70"}
                    ml-1 h-5 w-5 text-summer-green-800 transition ease-in-out duration-150`,
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Transition */ .u, {
                                as: react__WEBPACK_IMPORTED_MODULE_2__.Fragment,
                                enter: "transition ease-out duration-200",
                                enterFrom: "opacity-0 translate-y-1",
                                enterTo: "opacity-100 translate-y-0",
                                leave: "transition ease-in duration-150",
                                leaveFrom: "opacity-100 translate-y-0",
                                leaveTo: "opacity-0 translate-y-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Popover.Panel */ .J.Panel, {
                                    className: "absolute z-10 w-80 mt-0 transform -translate-x-16",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5",
                                        onMouseEnter: onMouseEnter.bind(null, open),
                                        onMouseLeave: onMouseLeave.bind(null, open),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative grid gap-8 bg-white p-7",
                                                children: solutions.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: item.href,
                                                        className: "flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex items-center justify-center flex-shrink-0 w-10 h-10 text-summer-green-700 bg-summer-green-100 border border-summer-green-300 rounded-lg sm:h-12 sm:w-12",
                                                                children: item.icon
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "ml-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm font-medium text-gray-900",
                                                                        children: item.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "text-sm text-gray-500",
                                                                        children: item.description
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, item.name))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "p-4 bg-gray-50",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    href: "https://docs.latencylingo.com/docs/intro",
                                                    className: "flow-root px-2 py-2 transition duration-150 ease-in-out rounded-md hover:bg-gray-100",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "flex items-center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-sm font-medium text-gray-900",
                                                                children: "Documentation"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "block text-sm text-gray-500",
                                                            children: "Start integrating Latency Lingo"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                });
            }
        })
    });
};
const Navbar = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: "m-auto text-gray-700 body-font max-w-7xl lg:max-w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container flex flex-col flex-wrap items-center p-5 mx-auto md:flex-row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/",
                    className: "flex items-center mb-4 font-medium text-san-juan-blue-500 title-font md:mb-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "w-auto h-8 sm:h-10",
                            src: "/img/logo.png",
                            alt: "Latency Lingo"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "ml-3 text-summer-green-700",
                            children: "Latency Lingo"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                    className: "flex flex-wrap items-center justify-center text-base md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-400",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductMenuLink, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "https://docs.latencylingo.com/docs/intro",
                            className: "mx-3 text-base text-san-juan-blue-500 hover:text-san-juan-blue-700",
                            rel: "noreferrer",
                            children: "Docs"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/#pricing",
                            className: "mx-3 text-base text-san-juan-blue-500 hover:text-san-juan-blue-700",
                            children: "Pricing"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/login",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "px-4 py-2 mt-4 mr-4 text-sm transition font-medium duration-150 ease-in-out text-san-juan-blue-500 bg-summer-green-400 border-summer-green-500 border rounded-md hover:bg-summer-green-500 focus:outline-none focus:border-summer-green-600 md:mt-0",
                                children: "Sign In"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/signup",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "px-4 py-2 mt-4 text-sm text-summer-green-700 font-medium border-summer-green-300 transition duration-150 ease-in-out border border-transparent rounded-md bg-summer-green-100 hover:bg-summer-green-200 focus:outline-none focus:border-summer-green-700 md:mt-0",
                                children: "Sign Up"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Navbar);


/***/ }),

/***/ 56925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);




const SEO = (props)=>{
    const { title , description , prefix , image  } = props;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const formattedTitle = title ? title : `${prefix ? `${prefix} | ` : ""}Latency Lingo`;
    const twitterTitle = title ? title : "Simple and collaborative performance testing analytics";
    const formattedImage = image ? `https://latencylingo.com/${image}` : "https://latencylingo.com/img/logo_full_v2.png";
    const formattedDescription = description ? description : "Latency Lingo helps software engineering teams gain insights on web performance testing metrics.";
    const formattedUrl = `https://latencylingo.com${router.asPath}`;
    const GoogleAnalytics = ()=>{
        if ( false || window.location.hostname == "localhost") {
            return null;
        }
        const gtags = [
            "G-NRT5TM5B5N",
            "UA-222320108-1"
        ];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                gtags.map((tag, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                        async: true,
                        src: `https://www.googletagmanager.com/gtag/js?id=${tag}`
                    }, i)),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                    dangerouslySetInnerHTML: {
                        __html: `
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                  ${gtags.map((tag)=>`gtag('config', '${tag}');`).join("\n")}
              `
                    }
                })
            ]
        });
    };
    const ClearBitAnalytics = ()=>{
        if ( false || window.location.hostname == "localhost") {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
            async: true,
            src: "https://tag.clearbitscripts.com/v1/pk_0e056f1cd6a691121103023fd96c1f74/tags.js",
            referrerPolicy: "strict-origin-when-cross-origin"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GoogleAnalytics, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClearBitAnalytics, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: formattedTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: formattedDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedImage,
                        property: "og:image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedUrl,
                        property: "og:url"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: "website",
                        property: "og:type"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedTitle,
                        property: "og:title"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedDescription,
                        property: "og:description"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "slack-app-id",
                        content: "A03KZAGKH8Q"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: twitterTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: formattedDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: formattedImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: "Latency Lingo"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/favicon/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "manifest",
                        href: "/favicon/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "mask-icon",
                        href: "/favicon/safari-pinned-tab.svg",
                        color: "#5bbad5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#2b5797"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 30453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Spinner = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 100 100",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M90.9 58.2c-3.8 18.9-20.1 32.7-39.7 33-22 .4-40.7-17-41.9-39C8 28.5 26.9 8.8 50.4 8.8c19 0 35.5 13.1 40 31.2.3 1.2 1.4 2.1 2.7 2.1 1.8 0 3.1-1.7 2.7-3.5C90.6 18.1 72 3.3 50.4 3.3c-27.2 0-49 23.4-46.6 51.1 2.1 23 21 41.2 44 42.4C71.6 98 91.7 81.9 96.2 59.4c.3-1.7-1-3.3-2.7-3.3-1.3-.1-2.4.8-2.6 2.1z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 99627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30453);


const Button = (param)=>{
    let { isLoading =false , title , children , ...buttonProps } = param;
    const { className , ...restButtonProps } = buttonProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: `w-full flex justify-center py-2 px-4 border border-summer-green-500 text-sm font-medium rounded-md text-san-juan-blue-500 bg-summer-green-400 hover:bg-summer-green-500 focus:outline-none transition duration-150 ease-in-out disabled:bg-gray-400 disabled:cursor-not-allowed ${className}`,
        ...restButtonProps,
        children: [
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                width: "20",
                fill: "#304D63",
                className: "animate-spin"
            }) : title,
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 83062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const NotificationBar = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-full text-md py-2 text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "inline-block max-w-4xl px-8 text-center",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotificationBar);


/***/ }),

/***/ 35806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/home/Layout.tsx
var Layout = __webpack_require__(90166);
// EXTERNAL MODULE: ./src/components/dashboard/Layout.tsx + 2 modules
var dashboard_Layout = __webpack_require__(59319);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/report.ts
var report = __webpack_require__(8384);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx + 1 modules
var useToast = __webpack_require__(43551);
// EXTERNAL MODULE: ./src/components/home/SEO.tsx
var SEO = __webpack_require__(56925);
// EXTERNAL MODULE: ./src/components/dashboard/MetricWidget.tsx
var MetricWidget = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/react-icons/si/index.esm.js
var index_esm = __webpack_require__(97735);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/gr/index.esm.js
var gr_index_esm = __webpack_require__(45155);
// EXTERNAL MODULE: ./src/components/dashboard/ObservationRow.tsx
var ObservationRow = __webpack_require__(36242);
// EXTERNAL MODULE: ./src/components/dashboard/ObservationForm.tsx
var ObservationForm = __webpack_require__(46162);
// EXTERNAL MODULE: ./src/services/observation.ts
var services_observation = __webpack_require__(2475);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(9253);
// EXTERNAL MODULE: ./node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(94831);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(3023);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(75358);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/Bar.js
var Bar = __webpack_require__(87226);
// EXTERNAL MODULE: ./node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(14888);
// EXTERNAL MODULE: ./src/components/dashboard/charts/helpers.ts
var helpers = __webpack_require__(85505);
// EXTERNAL MODULE: ./src/components/dashboard/charts/Loading.tsx
var Loading = __webpack_require__(7268);
// EXTERNAL MODULE: ./src/components/dashboard/charts/TooltipContent.tsx
var TooltipContent = __webpack_require__(75598);
;// CONCATENATED MODULE: ./src/components/dashboard/charts/RequestCount.tsx






const fillColors = [
    "#8FB9AA",
    "#5CCCCE",
    "#304D63",
    "#538573",
    "#E6A332"
];
const selectFillColor = (i)=>{
    return fillColors[i % (fillColors.length - 1)];
};
const RequestCount = (param)=>{
    let { ticks , charts , loading  } = param;
    const [formattedDataPoints, setFormattedDataPoints] = (0,react.useState)([]);
    const [labels, setLabels] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (charts) {
            setFormattedDataPoints((0,helpers/* fillInTimeGaps */.Qs)((0,helpers/* reduceChartsByLabel */.fg)(charts, "requests"), (timeStamp)=>({
                    timeStamp,
                    metricByLabel: {}
                }), (timeStamp, existing)=>({
                    timeStamp,
                    metricByLabel: existing.metricByLabel
                })));
            setLabels(Object.keys(charts));
        }
    }, [
        charts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-44 my-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
            width: "100%",
            height: "100%",
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                width: 500,
                height: 400,
                data: formattedDataPoints,
                margin: {
                    top: 10,
                    right: 30,
                    left: 10,
                    bottom: 10
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                        ...helpers/* commonXAxisProps */.Mh,
                        ticks: ticks
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {}),
                    labels.map((label, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            name: label,
                            label: label,
                            stackId: "a",
                            dataKey: (row)=>row.metricByLabel[label] || 0,
                            fill: selectFillColor(i)
                        }, i)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        content: TooltipContent/* default */.Z
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_RequestCount = (RequestCount);

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.js + 1 modules
var tabs = __webpack_require__(49808);
// EXTERNAL MODULE: ./node_modules/recharts/es6/chart/LineChart.js
var LineChart = __webpack_require__(98687);
// EXTERNAL MODULE: ./node_modules/recharts/es6/cartesian/Line.js
var Line = __webpack_require__(56880);
;// CONCATENATED MODULE: ./src/components/dashboard/charts/ResponseTime.tsx







const ResponseTime = (param)=>{
    let { ticks , charts , loading  } = param;
    // const [overallDataPoints, setOverallDataPoints] = useState<DataPoint[]>();
    const [formattedDataPoints, setFormattedDataPoints] = (0,react.useState)([]);
    const [labels, setLabels] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (charts) {
            setFormattedDataPoints((0,helpers/* fillInTimeGaps */.Qs)((0,helpers/* buildResponseTimePlots */.vs)(charts), (timeStamp)=>({
                    timeStamp,
                    metricByLabel: {}
                }), (timeStamp, existing)=>({
                    timeStamp,
                    metricByLabel: existing.metricByLabel
                })));
            setLabels([
                "Overall",
                ...Object.keys(charts).filter((l)=>l !== "Overall")
            ]);
        }
    }, [
        charts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* Tab.Group */.O.Group, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.List */.O.List, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        className: "px-3 border-b-2 border-gray-100 md:flex md:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    lineHeight: "3rem"
                                },
                                children: "Response Time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-flex flex-wrap mb-2 md:mx-4 rounded-xl bg-summer-green-100 p-1",
                                children: labels.map((label, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab */.O, {
                                        style: {
                                            maxWidth: "250px"
                                        },
                                        className: (param)=>{
                                            let { selected  } = param;
                                            return [
                                                "overflow-hidden text-ellipsis md:max-w-md whitespace-nowrap",
                                                "rounded-lg py-2.5 px-5 text-sm font-medium leading-5 text-summer-green-700",
                                                selected ? "bg-white border border-summer-green-200 shadow" : "hover:bg-summer-green-200"
                                            ].join(" ");
                                        },
                                        children: label
                                    }, i))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Panels */.O.Panels, {
                    children: labels.map((label, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tab.Panel */.O.Panel, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-44 my-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                    width: "100%",
                                    height: "100%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                                        width: 500,
                                        height: 400,
                                        data: formattedDataPoints,
                                        margin: {
                                            top: 10,
                                            right: 30,
                                            left: 10,
                                            bottom: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                ...helpers/* commonXAxisProps */.Mh,
                                                ticks: ticks
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                content: TooltipContent/* default */.Z
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                                dot: false,
                                                type: "monotone",
                                                dataKey: (row)=>row.metricByLabel[label]?.p50Ms,
                                                name: "p50 Latency (ms)",
                                                stroke: "#5CCCCE"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                                dot: false,
                                                type: "monotone",
                                                dataKey: (row)=>row.metricByLabel[label]?.p75Ms,
                                                name: "p75 Latency (ms)",
                                                stroke: "#38B8BA"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                                dot: false,
                                                type: "monotone",
                                                dataKey: (row)=>row.metricByLabel[label]?.p90Ms,
                                                name: "p90 Latency (ms)",
                                                stroke: "#5D8CB0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                                dot: false,
                                                type: "monotone",
                                                dataKey: (row)=>row.metricByLabel[label]?.p95Ms,
                                                name: "p95 Latency (ms)",
                                                stroke: "#3D627E"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                                dot: false,
                                                type: "monotone",
                                                dataKey: (row)=>row.metricByLabel[label]?.p99Ms,
                                                name: "p99 Latency (ms)",
                                                stroke: "#304D63"
                                            })
                                        ]
                                    })
                                })
                            })
                        }, i))
                })
            ]
        })
    });
};
/* harmony default export */ var charts_ResponseTime = (ResponseTime);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-table/build/umd/index.production.js
var index_production = __webpack_require__(24799);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/components/shared/Button.tsx
var Button = __webpack_require__(99627);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./src/components/dashboard/CompareReportForm.tsx






const CompareReportForm = (param)=>{
    let { onCompare  } = param;
    const router = (0,next_router.useRouter)();
    const [error, setError] = (0,react.useState)(null);
    const [loading, setLoading] = (0,react.useState)(false);
    const [compareReport, setCompareReport] = (0,react.useState)(null);
    const { register , handleSubmit , reset , formState: { errors  }  } = (0,dist_index_esm/* useForm */.cI)();
    const compareReportUuid = Array.isArray(router.query.compareReportUuid) ? router.query.compareReportUuid[0] : router.query.compareReportUuid;
    const handleLookup = (0,react.useCallback)((data)=>{
        setLoading(true);
        setError(null);
        (0,report/* getReport */.QL)(data.reportUuid).then((perfReport)=>{
            setLoading(false);
            onCompare(perfReport);
            setCompareReport(perfReport);
            router.push(`${router.asPath.split("?")[0]}?compareReportUuid=${perfReport.id}`, undefined, {
                shallow: true
            });
        }).catch((err)=>{
            setLoading(false);
            setError({
                message: `Failed to fetch report. ${err}`
            });
            console.error(err);
        });
    }, [
        onCompare,
        router
    ]);
    (0,react.useEffect)(()=>{
        if (compareReportUuid && !compareReport) {
            reset({
                reportUuid: compareReportUuid
            });
            handleLookup({
                reportUuid: compareReportUuid
            });
        }
    }, [
        reset,
        handleLookup,
        compareReportUuid,
        compareReport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(handleLookup),
        className: "md:inline-flex my-2 md:flex-wrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "w-full md:w-96 md:mr-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "reportUuid",
                        className: "block w-full mb-2 md:my-0 px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5",
                        type: "text",
                        name: "listingId",
                        placeholder: "Report ID",
                        autoComplete: "off",
                        ...register("reportUuid", {
                            required: "Please enter the report to compare with"
                        })
                    }),
                    (errors.reportUuid || error) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-2 text-xs text-red-600",
                        children: errors.reportUuid?.message || error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "w-full md:w-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Compare",
                    type: "submit",
                    isLoading: loading
                })
            })
        ]
    });
};
/* harmony default export */ var dashboard_CompareReportForm = (CompareReportForm);

;// CONCATENATED MODULE: ./src/components/dashboard/tables/ReportSummaryStats.tsx







const table = (0,index_production.createTable)().setRowType();
const renderCompareValue = function(row, metric) {
    let provider = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (row.compareMetrics) {
        const getVal = provider ? provider : (m)=>(0,lodash.get)(m, metric);
        const diffValue = Math.round(getVal(row.metrics) / getVal(row.compareMetrics) * 100) - 100;
        const className = diffValue < 0 ? "text-summer-green-500" : "text-apricot-500";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: className,
            children: `${diffValue || 0}%`
        });
    }
};
const calculateErrorRate = (metrics)=>{
    return Math.round(metrics.totalFailures / metrics.totalRequests);
};
const CellWithCompare = (param)=>{
    let { value , compareComponent , unit =null  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "flex justify-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    value,
                    unit
                ]
            }),
            compareComponent
        ]
    });
};
const defaultColumns = [
    table.createDataColumn("label", {
        cell: function labelCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    maxWidth: "400px"
                },
                className: "font-semibold overflow-hidden text-ellipsis whitespace-nowrap",
                children: info.getValue()
            });
        },
        header: "Label"
    }),
    table.createDataColumn((row)=>row.metrics.totalRequests, {
        id: "totalRequests",
        header: "Request count",
        cell: function totalRequestsCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, "totalRequests")
            });
        }
    }),
    table.createDataColumn((row)=>row.metrics.latencies.avgMs, {
        id: "avgResponseTime",
        header: "Avg. latency",
        cell: function avgResponseCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, "latencies.avgMs"),
                unit: "ms"
            });
        }
    }),
    table.createDataColumn((row)=>row.metrics.latencies.p75Ms, {
        id: "p75ResponseTime",
        header: "p75 latency",
        cell: function p75ResponseCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, "latencies.p75Ms"),
                unit: "ms"
            });
        }
    }),
    table.createDataColumn((row)=>row.metrics.latencies.p90Ms, {
        id: "p90ResponseTime",
        header: "p90 latency",
        cell: function p90ResponseCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, "latencies.p90Ms"),
                unit: "ms"
            });
        }
    }),
    table.createDataColumn((row)=>row.metrics.latencies.p99Ms, {
        id: "p99ResponseTime",
        header: "p99 latency",
        cell: function p99ResponseCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, "latencies.p99Ms"),
                unit: "ms"
            });
        }
    }),
    table.createDataColumn((row)=>row.metrics.latencies.minMs, {
        id: "minResponseTime",
        header: "Min latency",
        cell: function minResponseCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, "latencies.minMs"),
                unit: "ms"
            });
        }
    }),
    table.createDataColumn((row)=>row.metrics.latencies.maxMs, {
        id: "maxResponseTime",
        header: "Max latency",
        cell: function minResponseCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, "latencies.maxMs"),
                unit: "ms"
            });
        }
    }),
    table.createDataColumn((row)=>calculateErrorRate(row.metrics), {
        id: "errorRate",
        header: "Error rate",
        cell: function minResponseCell(info) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CellWithCompare, {
                value: info.getValue(),
                compareComponent: renderCompareValue(info.row.original, null, calculateErrorRate),
                unit: "%"
            });
        }
    })
];
const formatTableRows = function(performanceTest) {
    let compareReport = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    const rows = [];
    if (!performanceTest) {
        return rows;
    }
    rows.push({
        label: "ALL",
        metrics: performanceTest.metrics,
        compareMetrics: compareReport ? compareReport.metrics : null
    });
    Object.keys(performanceTest.metricsByLabel).forEach((label)=>{
        rows.push({
            label,
            metrics: performanceTest.metricsByLabel[label],
            compareMetrics: compareReport ? compareReport.metricsByLabel[label] : null
        });
    });
    return rows;
};
const ReportSummaryStats = (param)=>{
    let { performanceTest  } = param;
    const [data, setData] = (0,react.useState)(formatTableRows(performanceTest));
    const instance = (0,index_production.useTableInstance)(table, {
        data,
        columns: defaultColumns,
        getCoreRowModel: (0,index_production.getCoreRowModel)()
    });
    const [compareReport, setCompareReport] = (0,react.useState)(null);
    const [loading, setLoading] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (performanceTest) {
            setData(formatTableRows(performanceTest));
            setLoading(false);
        }
    }, [
        performanceTest
    ]);
    (0,react.useEffect)(()=>{
        if (performanceTest && compareReport) {
            // TODO(bobsin): notify when labels are mismatched
            setData(formatTableRows(performanceTest, compareReport));
            setLoading(false);
        }
    }, [
        performanceTest,
        compareReport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "pl-3 border-b-2 border-gray-100 md:flex md:justify-between",
                style: {
                    lineHeight: "3rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex flex-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Summary Stats"
                            }),
                            compareReport ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: `/reports/${compareReport.id}?compareReportUuid=${performanceTest.id}`,
                                target: "_blank",
                                className: "text-san-juan-blue-500 border border-san-juan-blue-600 border-dashed rounded px-3 md:ml-8 mb-2 font-normal",
                                rel: "noreferrer",
                                children: [
                                    "Comparing with report ",
                                    compareReport.label,
                                    ".",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiLinkExternal */.rpH, {
                                        className: "inline-block",
                                        size: "1.75rem"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_CompareReportForm, {
                        onCompare: setCompareReport
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "min-w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: instance.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                className: "border-b-2 border-gray-100",
                                children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        colSpan: header.colSpan,
                                        className: "text-gray-700 font-semibold text-left py-2 px-2",
                                        children: header.isPlaceholder ? null : header.renderHeader()
                                    }, header.id))
                            }, headerGroup.id))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: instance.getRowModel().rows.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "py-2 px-2 text-gray-700 font-normal",
                                        children: cell.renderCell()
                                    }, cell.id))
                            }, row.id))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tables_ReportSummaryStats = (ReportSummaryStats);

;// CONCATENATED MODULE: ./src/components/dashboard/charts/VirtualUsers.tsx






const VirtualUsers = (param)=>{
    let { ticks , charts , loading  } = param;
    const [overallDataPoints, setOverallDataPoints] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (charts && charts["Overall"]) {
            setOverallDataPoints((0,helpers/* fillInTimeGaps */.Qs)((0,helpers/* buildVirtualUserPlots */.NT)(charts["Overall"]), (timeStamp)=>({
                    timeStamp,
                    virtualUsers: 0
                }), (timeStamp, existing)=>({
                    timeStamp,
                    virtualUsers: existing.virtualUsers
                })));
        }
    }, [
        charts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "pb-4 pl-3 border-b-2 border-gray-100",
                children: "Virtual Users"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-44 my-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                    width: "100%",
                    height: "100%",
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                        width: 500,
                        height: 400,
                        data: overallDataPoints,
                        margin: {
                            top: 10,
                            right: 30,
                            left: 10,
                            bottom: 10
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                ...helpers/* commonXAxisProps */.Mh,
                                ticks: ticks
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                content: TooltipContent/* default */.Z
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                dataKey: "virtualUsers",
                                fill: "#304D63"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var charts_VirtualUsers = (VirtualUsers);

;// CONCATENATED MODULE: ./src/components/dashboard/tables/TestPlan.tsx




// TODO(bobsin): this shouldn't rely on chart data
const TestPlan = (param)=>{
    let { loading , reportTimeRange , labels  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "my-5 px-5 w-full text-lg text-gray-900",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "pl-3 font-semibold",
                children: "Test Plan"
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-5 pl-3 pt-2 border-t-2 border-gray-100 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base font-medium",
                                children: "Start time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base sm:col-span-2",
                                children: reportTimeRange[0] ? dayjs_min_default().unix(reportTimeRange[0]).format("MMMM D YYYY, h:mm:ss a") : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pl-3 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base font-medium",
                                children: "End time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base sm:col-span-2",
                                children: reportTimeRange[0] ? dayjs_min_default().unix(reportTimeRange[1]).format("MMMM D YYYY, h:mm:ss a") : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pl-3 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base font-medium",
                                children: "Duration"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base sm:col-span-2",
                                children: reportTimeRange.length > 0 ? (0,helpers/* durationFormatter */.yh)(reportTimeRange) : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pl-3 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base font-medium",
                                children: "Labels"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base sm:col-span-2",
                                children: labels.filter((label)=>label !== "Overall").map((label, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            maxWidth: "300px"
                                        },
                                        className: "inline-block mr-2 px-2 py-0.5 overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium rounded-full text-summer-green-700 border-summer-green-200 bg-summer-green-100",
                                        children: label
                                    }, i))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tables_TestPlan = (TestPlan);

;// CONCATENATED MODULE: ./src/components/dashboard/PerformanceReport.tsx



















const deriveTicks = (start, end)=>{
    const maxTicks = 10;
    // const defaultWindow = 5;
    const tickWindowOptions = [
        5,
        15,
        30,
        60,
        120,
        180,
        300,
        600,
        1800
    ];
    const duration = end - start;
    // NOTE(bobsin): this finds the option where
    // duration / option is less than max ticks desired
    const possibleTickWindows = tickWindowOptions.filter((tickWindow)=>duration / tickWindow < maxTicks);
    const selectedTickWindow = possibleTickWindows[0];
    // TODO(bobsin): handle selectedTickWindow == undefined
    const ticks = [];
    // TODO(bobsin): change this to begin on the start of tickWindow
    let currentTick = start;
    // TODO(bobsin): improve safety of this while loop
    while(currentTick + selectedTickWindow <= end){
        currentTick += selectedTickWindow;
        ticks.push(currentTick);
    }
    return ticks;
};
const isDemoReport = (query)=>{
    const slugValue = (query.slug || [])[0];
    return slugValue === "demo";
};
const PerformanceReport = (param)=>{
    let { perfReport  } = param;
    const { addToast  } = (0,useToast/* useToast */.p)();
    const { query  } = (0,next_router.useRouter)();
    const [reportTimeRange, setReportTimeRange] = (0,react.useState)([]);
    const [observations, setObservations] = (0,react.useState)({});
    const [ticks, setTicks] = (0,react.useState)([]);
    const [chartsByLabel, setChartsByLabel] = (0,react.useState)(null);
    const [chartsLoading, setChartsLoading] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        // TODO(bobsin); put this in a setTimeout to allow nested useEffect to run
        if (perfReport) {
            (0,services_observation/* getObservations */._A)(perfReport.id).then(setObservations).catch(console.warn);
            if (!chartsByLabel) {
                // TODO(bobsin): improve error handling
                (0,report/* getReportChartDataV1 */.Tx)(perfReport.id).then((byLabel)=>{
                    setChartsByLabel(byLabel);
                    const start = byLabel["Overall"].timeStamps.at(0);
                    const end = byLabel["Overall"].timeStamps.at(-1);
                    setReportTimeRange([
                        start,
                        end
                    ]);
                    setTicks(deriveTicks(start, end));
                    setChartsLoading(false);
                }).catch((error)=>{
                    addToast({
                        title: "Error loading charts",
                        description: error.message,
                        type: "error"
                    });
                });
            }
        }
    }, [
        addToast,
        perfReport,
        chartsByLabel
    ]);
    const onSubmitConclusion = (cls)=>{
        (0,services_observation/* createObservation */.on)({
            ...cls,
            reportId: perfReport.id
        }).then((created)=>{
            setObservations({
                ...observations,
                [created.subject]: [
                    ...observations[created.subject] || [],
                    created
                ]
            });
            addToast({
                title: "Documented new conclusion",
                description: created.description,
                type: "success"
            });
        }).catch(console.error);
    };
    const onChangeObservation = (observation)=>{
        (0,services_observation/* updateObservation */.mN)({
            reportId: perfReport.id,
            observation
        }).then((updated)=>{
            setObservations({
                ...observations,
                [updated.subject]: observations[updated.subject].map((obs)=>obs.id === updated.id ? updated : obs)
            });
            addToast({
                title: "Updated status",
                description: updated.description,
                type: "success"
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-4 py-10 pb-12 mx-auto max-w-7xl sm:px-6 lg:px-8 lg:max-w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: "pb-4 pl-3 mb-6 border-b-2 border-gray-100 sm:py-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-2 md:flex md:items-center md:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 min-w-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:leading-9 sm:truncate",
                                    children: perfReport?.label
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-lg text-gray-800",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: reportTimeRange[0] ? dayjs_min_default().unix(reportTimeRange[0]).format("MMMM D YYYY, h:mm:ss a") : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: reportTimeRange[1] ? dayjs_min_default().unix(reportTimeRange[1]).format("MMMM D YYYY, h:mm:ss a") : ""
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 grid grid-cols-1 gap-5 sm:grid-cols-3 lg:grid-cols-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricWidget/* default */.Z, {
                            label: "Requests",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(gr_index_esm/* GrSend */.b_K, {
                                className: "h-6 w-6"
                            }),
                            value: `${perfReport ? perfReport.metrics.totalRequests : 0}`
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricWidget/* default */.Z, {
                            label: "Failures",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiErrorCircle */.Cw1, {
                                className: "h-6 w-6 text-apricot-500"
                            }),
                            value: `${perfReport ? perfReport.metrics.totalFailures : 0}`
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricWidget/* default */.Z, {
                            label: "Test Duration",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiTimer */.b3O, {
                                className: "h-6 w-6 text-new-orleans-600"
                            }),
                            value: reportTimeRange.length > 0 ? (0,helpers/* durationFormatter */.yh)(reportTimeRange) : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricWidget/* default */.Z, {
                            label: "Virtual Users",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(bi_index_esm/* BiUser */.EDj, {
                                className: "h-6 w-6 text-summer-green-500"
                            }),
                            value: `${perfReport ? perfReport.metrics.maxVirtualUsers : 0}`
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricWidget/* default */.Z, {
                            label: "Average Latency",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SiPagespeedinsights */.GTs, {
                                className: "h-6 w-6 text-san-juan-blue-400"
                            }),
                            value: `${perfReport ? perfReport.metrics.latencies.avgMs : 0}ms`
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricWidget/* default */.Z, {
                            label: "p90 Latency",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SiPagespeedinsights */.GTs, {
                                className: "h-6 w-6 text-san-juan-blue-400"
                            }),
                            value: `${perfReport?.metrics?.latencies?.p90Ms || 0}ms`
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 grid grid-cols-1 gap-5 sm:grid-cols-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sm:col-span-3 overflow-hidden bg-white rounded-lg shadow-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tables_TestPlan, {
                                loading: chartsLoading,
                                reportTimeRange: reportTimeRange,
                                labels: Object.keys(chartsByLabel || {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sm:col-span-2 overflow-hidden bg-white rounded-lg shadow-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-5 px-5 w-full text-lg text-gray-900",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                        className: "pl-3 font-semibold",
                                        children: "Observations"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "mt-5",
                                        children: [
                                            observations.conclusion?.map((obj, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "border-t-2 border-gray-100",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationRow/* default */.Z, {
                                                        observation: obj,
                                                        onChange: onChangeObservation
                                                    })
                                                }, i);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "border-t-2 border-gray-100",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationForm/* default */.Z, {
                                                    handleSubmit: onSubmitConclusion,
                                                    disableSubmit: isDemoReport(query),
                                                    subject: "conclusion",
                                                    subjectLabel: "observation"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-8 overflow-hidden bg-white rounded-lg shadow-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-5 w-full overflow-x-scroll lg:overflow-x-hidden text-lg font-semibold text-gray-900",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tables_ReportSummaryStats, {
                            performanceTest: perfReport
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-8 overflow-hidden bg-white rounded-lg shadow-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-5 px-5 w-full text-lg font-semibold text-gray-900",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                className: "pb-4 pl-3 border-b-2 border-gray-100",
                                children: "Total Requests"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_RequestCount, {
                                ticks: ticks,
                                charts: chartsByLabel,
                                loading: chartsLoading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "mt-5",
                                children: [
                                    observations.totalRequests?.map((obj, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "border-t-2 border-gray-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationRow/* default */.Z, {
                                                observation: obj,
                                                onChange: onChangeObservation
                                            })
                                        }, i);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "border-t-2 border-gray-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationForm/* default */.Z, {
                                            handleSubmit: onSubmitConclusion,
                                            disableSubmit: isDemoReport(query),
                                            subject: "totalRequests",
                                            subjectLabel: "observation"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-8 overflow-hidden bg-white rounded-lg shadow-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-5 px-5 w-full text-lg font-semibold text-gray-900",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_ResponseTime, {
                                charts: chartsByLabel,
                                ticks: ticks,
                                loading: chartsLoading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "mt-5",
                                children: [
                                    observations.responseTime?.map((obj, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "border-t-2 border-gray-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationRow/* default */.Z, {
                                                observation: obj,
                                                onChange: onChangeObservation
                                            })
                                        }, i);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "border-t-2 border-gray-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationForm/* default */.Z, {
                                            handleSubmit: onSubmitConclusion,
                                            subject: "responseTime",
                                            subjectLabel: "observation"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-8 overflow-hidden bg-white rounded-lg shadow-md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-5 px-5 w-full text-lg font-semibold text-gray-900",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_VirtualUsers, {
                                charts: chartsByLabel,
                                ticks: ticks,
                                loading: chartsLoading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "mt-5",
                                children: [
                                    observations.virtualUsers?.map((obj, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "border-t-2 border-gray-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationRow/* default */.Z, {
                                                observation: obj,
                                                onChange: onChangeObservation
                                            })
                                        }, i);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "border-t-2 border-gray-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ObservationForm/* default */.Z, {
                                            handleSubmit: onSubmitConclusion,
                                            subject: "virtualUsers",
                                            subjectLabel: "observation"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var dashboard_PerformanceReport = (PerformanceReport);

// EXTERNAL MODULE: ./src/components/icons/Spinner.tsx
var Spinner = __webpack_require__(30453);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx
var useAuth = __webpack_require__(18424);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/pages/reports/[...slug].tsx













const getReportUuid = (query)=>{
    const slugValue = (query.slug || [])[0];
    return slugValue === "demo" ? "bdd8ce59-8c93-431f-aea9-d53d3ad03182" : slugValue;
};
const ReportPage = ()=>{
    const { user  } = (0,useAuth/* useAuth */.a)();
    const router = (0,next_router.useRouter)();
    const { addToast  } = (0,useToast/* useToast */.p)();
    const reportUuid = getReportUuid(router.query);
    const [perfReport, setPerfReport] = (0,react.useState)();
    const [loading, setLoading] = (0,react.useState)(true);
    const SelectedLayout = user ? dashboard_Layout/* default */.Z : Layout/* default */.Z;
    (0,react.useEffect)(()=>{
        if (reportUuid) {
            (0,report/* getReport */.QL)(reportUuid).then((report)=>{
                setPerfReport(report);
                setLoading(false);
            }).catch((error)=>{
                console.error(error);
                setLoading(false);
                addToast({
                    title: "Unknown report URL",
                    description: `Could not find a report with ID ${reportUuid}`,
                    type: "error"
                });
            });
        }
    }, [
        addToast,
        reportUuid
    ]);
    const Loading = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-2/3 flex flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                width: "40",
                className: "flex-1 m-auto mt-6 animate-spin"
            })
        });
    const NotFound = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full mt-10 sm:mt-16 py-10 max-w-2xl mx-auto bg-white rounded-lg flex flex-col text-center text-sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "object-cover mx-auto rounded-lg w-2/3 max-w-sm",
                    alt: "blank.canvas",
                    src: "/img/undraw_done_checking_re_6vyx.jpg",
                    loading: "lazy"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-5 px-5",
                    children: [
                        "Could not find the report.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: `/login?returnTo=${router.asPath}`,
                            className: "text-royal-blue-600",
                            children: "Login"
                        }),
                        " ",
                        "for access or create a new report."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://docs.latencylingo.com/docs/getting-started",
                        target: "_self",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            title: "Learn how to create a report"
                        })
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                prefix: "Report"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedLayout, {
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {}),
                    !loading && !perfReport && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {}),
                    !loading && perfReport && /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_PerformanceReport, {
                        perfReport: perfReport
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _slug_ = (ReportPage);


/***/ }),

/***/ 3066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ fireConverter; }
/* harmony export */ });
const fireConverter = ()=>({
        toFirestore: (data)=>data,
        fromFirestore: (snap)=>snap.data()
    });


/***/ }),

/***/ 2475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_A": function() { return /* binding */ getObservations; },
/* harmony export */   "mN": function() { return /* binding */ updateObservation; },
/* harmony export */   "on": function() { return /* binding */ createObservation; }
/* harmony export */ });
/* harmony import */ var config_firebase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82945);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57632);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15503);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3066);




const lookupDocumentRef = async (reportId)=>{
    const observationsDocRef = await config_firebase__WEBPACK_IMPORTED_MODULE_0__.db.collection("report-observations").withConverter((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fireConverter */ .B)()).doc(reportId).get();
    if (observationsDocRef.exists) {
        return observationsDocRef;
    } else {
        throw "Report not found";
    }
};
const getObservations = async (reportId)=>{
    return (await lookupDocumentRef(reportId)).data();
};
const createObservation = async (data)=>{
    const observation = {
        ...data,
        id: (0,uuid__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()
    };
    return config_firebase__WEBPACK_IMPORTED_MODULE_0__.db.collection("report-observations").doc(data.reportId).set({
        [data.subject]: firebase_app__WEBPACK_IMPORTED_MODULE_1__/* ["default"].firestore.FieldValue.arrayUnion */ .Z.firestore.FieldValue.arrayUnion(observation)
    }, {
        merge: true
    }).then((_)=>observation);
};
const updateObservation = async (data)=>{
    const docRef = await lookupDocumentRef(data.reportId);
    const newObservations = docRef.data()[data.observation.subject].map((observation)=>observation.id === data.observation.id ? data.observation : observation);
    return config_firebase__WEBPACK_IMPORTED_MODULE_0__.db.collection("report-observations").doc(data.reportId).set({
        [data.observation.subject]: newObservations
    }, {
        merge: true
    }).then((_)=>data.observation);
};


/***/ }),

/***/ 8384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QL": function() { return /* binding */ getReport; },
/* harmony export */   "Tx": function() { return /* binding */ getReportChartDataV1; },
/* harmony export */   "Zn": function() { return /* binding */ createReport; }
/* harmony export */ });
/* unused harmony exports getRecentReports, deleteReport */
/* harmony import */ var config_firebase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82945);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3066);
/* harmony import */ var _supabase_supabase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30218);



const supabase = (0,_supabase_supabase_js__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .eI)("https://cugddtipnsjmjfmrxbsn.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN1Z2RkdGlwbnNqbWpmbXJ4YnNuIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTYzNzI1NDEsImV4cCI6MTk3MTk0ODU0MX0.ZiOxh9HYAwmSpbxMk5qNZoHoIiimadsawg6KlWkbPy4");
const getReport = async (reportUuid)=>{
    const reportDocRef = await config_firebase__WEBPACK_IMPORTED_MODULE_0__.db.collection("reports").withConverter((0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .fireConverter */ .B)()).doc(reportUuid).get();
    if (reportDocRef.exists) {
        return reportDocRef.data();
    } else {
        throw "Report not found";
    }
};
const getRecentReports = async (uid)=>{
    const from = new Date();
    from.setTime(from.getTime() - 24 * 60 * 60 * 1000 * 30);
    // TODO(bobsin): better support pages
    const queryRef = await db.collection("reports").withConverter(fireConverter()).where("createdAt", ">", Math.floor(from.getTime() / 1000)).where("userId", "==", uid).orderBy("createdAt", "desc").limit(20).get();
    return queryRef.docs.map((doc)=>doc.data());
};
const createReport = async (label)=>{
    const result = await config_firebase__WEBPACK_IMPORTED_MODULE_0__/* .functions.httpsCallable */ .wk.httpsCallable("createReport")({
        label
    });
    return result.data.data;
};
const deleteReport = async (reportUuid)=>{
    return db.collection("reports").withConverter(fireConverter()).doc(reportUuid).delete();
};
const getReportChartDataV1 = async (reportId)=>{
    const { data , error  } = await supabase.rpc("get_report_chart_data_v1", {
        report_id: reportId
    });
    if (error) {
        throw error;
    }
    return data.reduce((acc, curr)=>{
        acc[curr.label] = curr;
        return acc;
    }, {});
};


/***/ }),

/***/ 86215:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mt; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64103);
/* harmony import */ var _utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84575);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14157);
/* harmony import */ var _hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39650);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51074);
/* harmony import */ var _hooks_use_event_listener_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14007);
/* harmony import */ var _internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46045);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73781);
/* harmony import */ var _hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70638);
var Ae=(f=>(f[f.Open=0]="Open",f[f.Closed=1]="Closed",f))(Ae||{}),Ce=(n=>(n[n.TogglePopover=0]="TogglePopover",n[n.ClosePopover=1]="ClosePopover",n[n.SetButton=2]="SetButton",n[n.SetButtonId=3]="SetButtonId",n[n.SetPanel=4]="SetPanel",n[n.SetPanelId=5]="SetPanelId",n))(Ce||{});let Re={[0]:r=>({...r,popoverState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(r.popoverState,{[0]:1,[1]:0})}),[1](r){return r.popoverState===1?r:{...r,popoverState:1}},[2](r,t){return r.button===t.button?r:{...r,button:t.button}},[3](r,t){return r.buttonId===t.buttonId?r:{...r,buttonId:t.buttonId}},[4](r,t){return r.panel===t.panel?r:{...r,panel:t.panel}},[5](r,t){return r.panelId===t.panelId?r:{...r,panelId:t.panelId}}},te=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);te.displayName="PopoverContext";function Q(r){let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(te);if(t===null){let f=new Error(`<${r} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(f,Q),f}return t}let oe=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);oe.displayName="PopoverAPIContext";function re(r){let t=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(oe);if(t===null){let f=new Error(`<${r} /> is missing a parent <Popover /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(f,re),f}return t}let ne=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);ne.displayName="PopoverGroupContext";function ce(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ne)}let le=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);le.displayName="PopoverPanelContext";function Oe(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(le)}function Me(r,t){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(t.type,Re,r,t)}let Le="div",Ie=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,f){var O;let o=`headlessui-popover-button-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,v=`headlessui-popover-panel-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),n=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(f,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .optionalRef */ .h)(e=>{a.current=e})),g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Me,{popoverState:1,button:null,buttonId:o,panel:null,panelId:v,beforePanelSentinel:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)(),afterPanelSentinel:(0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)()}),[{popoverState:y,button:l,panel:P,beforePanelSentinel:s,afterPanelSentinel:B},i]=g,T=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .useOwnerDocument */ .i)((O=a.current)!=null?O:l);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>i({type:3,buttonId:o}),[o,i]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>i({type:5,panelId:v}),[v,i]);let c=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{if(!l||!P)return!1;for(let M of document.querySelectorAll("body > *"))if(Number(M==null?void 0:M.contains(l))^Number(M==null?void 0:M.contains(P)))return!0;let e=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .getFocusableElements */ .GO)(),p=e.indexOf(l),m=(p+e.length-1)%e.length,C=(p+1)%e.length,D=e[m],V=e[C];return!P.contains(D)&&!P.contains(V)},[l,P]),d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({buttonId:o,panelId:v,close:()=>i({type:1})}),[o,v,i]),E=ce(),A=E==null?void 0:E.registerPopover,L=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(()=>{var e;return(e=E==null?void 0:E.isFocusWithinPopoverGroup())!=null?e:(T==null?void 0:T.activeElement)&&((l==null?void 0:l.contains(T.activeElement))||(P==null?void 0:P.contains(T.activeElement)))});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>A==null?void 0:A(d),[A,d]),(0,_hooks_use_event_listener_js__WEBPACK_IMPORTED_MODULE_8__/* .useEventListener */ .O)(T==null?void 0:T.defaultView,"focus",e=>{var p,m,C,D;y===0&&(L()||!l||!P||(m=(p=s.current)==null?void 0:p.contains)!=null&&m.call(p,e.target)||(D=(C=B.current)==null?void 0:C.contains)!=null&&D.call(C,e.target)||i({type:1}))},!0),(0,_hooks_use_outside_click_js__WEBPACK_IMPORTED_MODULE_9__/* .useOutsideClick */ .O)([l,P],(e,p)=>{i({type:1}),(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .isFocusableElement */ .sP)(p,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .FocusableMode.Loose */ .tJ.Loose)||(e.preventDefault(),l==null||l.focus())},y===0);let I=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(e=>{i({type:1});let p=(()=>e?e instanceof HTMLElement?e:"current"in e&&e.current instanceof HTMLElement?e.current:l:l)();p==null||p.focus()}),H=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:I,isPortalled:c}),[I,c]),u=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:y===0,close:I}),[y,I]),S=t,R={ref:n};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(te.Provider,{value:g},react__WEBPACK_IMPORTED_MODULE_0__.createElement(oe.Provider,{value:H},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(y,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:R,theirProps:S,slot:u,defaultTag:Le,name:"Popover"}))))}),Fe="button",he=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,f){let[o,v]=Q("Popover.Button"),{isPortalled:a}=re("Popover.Button"),n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),g=`headlessui-focus-sentinel-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,y=ce(),l=y==null?void 0:y.closeOthers,P=Oe(),s=P===null?!1:P===o.panelId,B=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(n,f,s?null:e=>e&&v({type:2,button:e})),i=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(n,f),T=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .useOwnerDocument */ .i)(n),c=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(e=>{var p,m,C;if(s){if(o.popoverState===1)return;switch(e.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Enter */ .R.Enter:e.preventDefault(),(m=(p=e.target).click)==null||m.call(p),v({type:1}),(C=o.button)==null||C.focus();break}}else switch(e.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Enter */ .R.Enter:e.preventDefault(),e.stopPropagation(),o.popoverState===1&&(l==null||l(o.buttonId)),v({type:0});break;case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Escape */ .R.Escape:if(o.popoverState!==0)return l==null?void 0:l(o.buttonId);if(!n.current||(T==null?void 0:T.activeElement)&&!n.current.contains(T.activeElement))return;e.preventDefault(),e.stopPropagation(),v({type:1});break}}),d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(e=>{s||e.key===_keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Space */ .R.Space&&e.preventDefault()}),E=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(e=>{var p,m;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__/* .isDisabledReactIssue7711 */ .P)(e.currentTarget)||t.disabled||(s?(v({type:1}),(p=o.button)==null||p.focus()):(e.preventDefault(),e.stopPropagation(),o.popoverState===1&&(l==null||l(o.buttonId)),v({type:0}),(m=o.button)==null||m.focus()))}),A=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(e=>{e.preventDefault(),e.stopPropagation()}),L=o.popoverState===0,I=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:L}),[L]),H=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_13__/* .useResolveButtonType */ .f)(t,n),u=t,S=s?{ref:i,type:H,onKeyDown:c,onClick:E}:{ref:B,id:o.buttonId,type:H,"aria-expanded":t.disabled?void 0:o.popoverState===0,"aria-controls":o.panel?o.panelId:void 0,onKeyDown:c,onKeyUp:d,onClick:E,onMouseDown:A},R=(0,_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .useTabDirection */ .l)(),O=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(()=>{let e=o.panel;if(!e)return;function p(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(R.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Forwards */ .N.Forwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .focusIn */ .jA)(e,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .Focus.First */ .TO.First),[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Backwards */ .N.Backwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .focusIn */ .jA)(e,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .Focus.Last */ .TO.Last)})}p()});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:S,theirProps:u,slot:I,defaultTag:Fe,name:"Popover.Button"}),L&&!s&&a&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Hidden */ ._,{id:g,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Features.Focusable */ .A.Focusable,as:"button",type:"button",onFocus:O}))}),Be="div",De=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,xe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,f){let[{popoverState:o},v]=Q("Popover.Overlay"),a=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(f),n=`headlessui-popover-overlay-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,g=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .useOpenClosed */ .oJ)(),y=(()=>g!==null?g===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open:o===0)(),l=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(i=>{if((0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_12__/* .isDisabledReactIssue7711 */ .P)(i.currentTarget))return i.preventDefault();v({type:1})}),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:o===0}),[o]);return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:{ref:a,id:n,"aria-hidden":!0,onClick:l},theirProps:t,slot:P,defaultTag:Be,features:De,visible:y,name:"Popover.Overlay"})}),He="div",Ge=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,ke=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,f){let{focus:o=!1,...v}=t,[a,n]=Q("Popover.Panel"),{close:g,isPortalled:y}=re("Popover.Panel"),l=`headlessui-focus-sentinel-before-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,P=`headlessui-focus-sentinel-after-${(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)()}`,s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),B=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(s,f,u=>{n({type:4,panel:u})}),i=(0,_hooks_use_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .useOwnerDocument */ .i)(s),T=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .useOpenClosed */ .oJ)(),c=(()=>T!==null?T===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_10__/* .State.Open */ .ZM.Open:a.popoverState===0)(),d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(u=>{var S;switch(u.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_11__/* .Keys.Escape */ .R.Escape:if(a.popoverState!==0||!s.current||(i==null?void 0:i.activeElement)&&!s.current.contains(i.activeElement))return;u.preventDefault(),u.stopPropagation(),n({type:1}),(S=a.button)==null||S.focus();break}});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{var u;t.static||a.popoverState===1&&((u=t.unmount)!=null?u:!0)&&n({type:4,panel:null})},[a.popoverState,t.unmount,t.static,n]),(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!o||a.popoverState!==0||!s.current)return;let u=i==null?void 0:i.activeElement;s.current.contains(u)||(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .focusIn */ .jA)(s.current,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .Focus.First */ .TO.First)},[o,s,a.popoverState]);let E=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:a.popoverState===0,close:g}),[a,g]),A={ref:B,id:a.panelId,onKeyDown:d,onBlur:o&&a.popoverState===0?u=>{var R,O,e,p,m;let S=u.relatedTarget;!S||!s.current||(R=s.current)!=null&&R.contains(S)||(n({type:1}),(((e=(O=a.beforePanelSentinel.current)==null?void 0:O.contains)==null?void 0:e.call(O,S))||((m=(p=a.afterPanelSentinel.current)==null?void 0:p.contains)==null?void 0:m.call(p,S)))&&S.focus({preventScroll:!0}))}:void 0,tabIndex:-1},L=(0,_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .useTabDirection */ .l)(),I=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(()=>{let u=s.current;if(!u)return;function S(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(L.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Forwards */ .N.Forwards]:()=>{(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .focusIn */ .jA)(u,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .Focus.First */ .TO.First)},[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Backwards */ .N.Backwards]:()=>{var R;(R=a.button)==null||R.focus({preventScroll:!0})}})}S()}),H=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(()=>{let u=s.current;if(!u)return;function S(){(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(L.current,{[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Forwards */ .N.Forwards]:()=>{var C,D,V;if(!a.button)return;let R=(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .getFocusableElements */ .GO)(),O=R.indexOf(a.button),e=R.slice(0,O+1),m=[...R.slice(O+1),...e];for(let M of m.slice())if(((D=(C=M==null?void 0:M.id)==null?void 0:C.startsWith)==null?void 0:D.call(C,"headlessui-focus-sentinel-"))||((V=a.panel)==null?void 0:V.contains(M))){let ae=m.indexOf(M);ae!==-1&&m.splice(ae,1)}(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .focusIn */ .jA)(m,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .Focus.First */ .TO.First,!1)},[_hooks_use_tab_direction_js__WEBPACK_IMPORTED_MODULE_14__/* .Direction.Backwards */ .N.Backwards]:()=>(0,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .focusIn */ .jA)(u,_utils_focus_management_js__WEBPACK_IMPORTED_MODULE_6__/* .Focus.Last */ .TO.Last)})}S()});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(le.Provider,{value:a.panelId},c&&y&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Hidden */ ._,{id:l,ref:a.beforePanelSentinel,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Features.Focusable */ .A.Focusable,as:"button",type:"button",onFocus:I}),(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:A,theirProps:v,slot:E,defaultTag:He,features:Ge,visible:c,name:"Popover.Panel"}),c&&y&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Hidden */ ._,{id:P,ref:a.afterPanelSentinel,features:_internal_hidden_js__WEBPACK_IMPORTED_MODULE_15__/* .Features.Focusable */ .A.Focusable,as:"button",type:"button",onFocus:H}))}),_e="div",we=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(t,f){let o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),v=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_4__/* .useSyncRefs */ .T)(o,f),[a,n]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),g=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(c=>{n(d=>{let E=d.indexOf(c);if(E!==-1){let A=d.slice();return A.splice(E,1),A}return d})}),y=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(c=>(n(d=>[...d,c]),()=>g(c))),l=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(()=>{var E;let c=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_16__/* .getOwnerDocument */ .r)(o);if(!c)return!1;let d=c.activeElement;return(E=o.current)!=null&&E.contains(d)?!0:a.some(A=>{var L,I;return((L=c.getElementById(A.buttonId))==null?void 0:L.contains(d))||((I=c.getElementById(A.panelId))==null?void 0:I.contains(d))})}),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_7__/* .useEvent */ .z)(c=>{for(let d of a)d.buttonId!==c&&d.close()}),s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({registerPopover:y,unregisterPopover:g,isFocusWithinPopoverGroup:l,closeOthers:P}),[y,g,l,P]),B=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({}),[]),i=t,T={ref:v};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ne.Provider,{value:s},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:T,theirProps:i,slot:B,defaultTag:_e,name:"Popover.Group"}))}),mt=Object.assign(Ie,{Button:he,Overlay:xe,Panel:ke,Group:we});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,1228,8907,3415,3662,6158,1664,5754,6880,218,1107,5795,9319,9774,2888,179], function() { return __webpack_exec__(2463); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);